import { Accordion, AccordionDetails, AccordionSummary, Box, Paper, Typography } from "@material-ui/core";
import { Controlled as CodeMirror } from "react-codemirror2";
import React from "react";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/neat.css";
import "codemirror/mode/xml/xml.js";
import "codemirror/mode/javascript/javascript.js";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useTranslation } from "react-i18next";

interface VariablesProps {
    variables: string;
    onSetVariables(body: string): void;
}

const EDITOR_HEIGHT = "100px";

export const VariablesViewer: React.FC<VariablesProps> = ({ variables, onSetVariables }) => {
    const { t } = useTranslation();

    return (
        <Accordion defaultExpanded variant="outlined">
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="body1" color="textSecondary">
                    {t("templates.overview.label.variables")}
                </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ display: "block" }}>
                <Box component={Paper} mb={1}>
                    <CodeMirror
                        value={variables}
                        editorDidMount={(editor) => {
                            editor.setSize("", EDITOR_HEIGHT);
                        }}
                        options={{
                            htmlMode: true,
                            lineNumbers: true,
                            lineWrapping: true,
                        }}
                        onBeforeChange={(editor, data, value) => {
                            onSetVariables(value);
                        }}
                    />
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};
